import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-register-success',
  templateUrl: './register-success.component.html',
  styleUrls: ['./register-success.component.scss'],
})
export class RegisterSuccessComponent implements OnInit {
  tenant: string = '';
  merchant: string = '';
  personType: string = '';

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private merchantService: MerchantService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const tenant = params.get('tenant');
      if (tenant) this.tenant = params.get('tenant');
      const personType = params.get('personType');
      if (personType) this.personType = params.get('personType');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);
  }

  goToLogin() {
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }
}
